module.exports = __webpack_public_path__ + "media/bootstrap-icons/diagram-2-2a2911f5.svg";